import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Box
} from '@mui/material';

const SaveQueryDialog = ({ open, onClose, onSave, currentQuery, selectedFields }) => {
  const [queryName, setQueryName] = useState('');
  const [isFavorite, setIsFavorite] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      if (currentQuery) {
        setQueryName(currentQuery.name);
        setIsFavorite(currentQuery.isFavorite || false);
      } else {
        setQueryName('');
        setIsFavorite(false);
      }
      setError('');
    }
  }, [open, currentQuery]);

  const handleSave = () => {
    if (!queryName.trim()) {
      setError('Query name is required');
      return;
    }

    if (queryName.length > 100) {
      setError('Query name must be 100 characters or less');
      return;
    }

    if (selectedFields.length === 0) {
      setError('Cannot save empty query');
      return;
    }

    onSave({
      id: currentQuery?.id,
      name: queryName.trim(),
      selectedFields,
      isFavorite
    });

    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>{currentQuery ? 'Update Query' : 'Save Query'}</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <TextField
            autoFocus
            fullWidth
            label='Query Name'
            value={queryName}
            onChange={(e) => setQueryName(e.target.value)}
            error={!!error}
            helperText={error}
            inputProps={{ maxLength: 100 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isFavorite}
                onChange={(e) => setIsFavorite(e.target.checked)}
              />
            }
            label='Mark as favorite'
            sx={{ mt: 2 }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant='contained' color='primary'>
          {currentQuery ? 'Update' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveQueryDialog;
